@if (userRoleGroupView) {
  <div class="main-container">
    @if (!isAddRoleGroup) {
      <div [formGroup]="addRoleGroupForm">
        <div class="page-header">
          <div class="routing-buttons">
            <div
              class="action-button back-button"
              (click)="navigateBack()"
              tabindex="0"
              (keydown.enter)="navigateBack()"
            >
              <mat-icon class="icon back-icon">arrow_back</mat-icon>
            </div>
            <div
              class="action-button reload-button"
              (click)="ngOnInit()"
              tabindex="0"
              (keydown.enter)="ngOnInit()"
            >
              <mat-icon class="icon reload-icon">refresh</mat-icon>
            </div>
            <span class="page-title">Group Management</span>
          </div>
          <!-- Redirect Button -->
          <div class="button-group">
            @if (userRoleGroupCreate) {
              <button class="primary-button" (click)="addRoleGroup('add')">
                Add Group <mat-icon class="btn-icon">open_in_new</mat-icon>
              </button>
            }
          </div>
        </div>
        <div class="component-container">
          <!-- Component Header Section -->
          <div class="component-header">
            <h6 class="component-title">Group List</h6>
            <div class="component-actions">
              <app-common-search
                (searchSubmit)="onSearchRoleName($event)"
              ></app-common-search>
            </div>
          </div>

          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>

          <!-- Component Body Section -->
          <div class="component-body">
            <table>
              <thead>
                <tr>
                  <th>Group Name</th>
                  <th>Created At</th>
                  <th>Action</th>
                </tr>
              </thead>
              @if (listOfRoleGroup.length > 0) {
                <tbody>
                  @for (item of listOfRoleGroup; track item) {
                    <tr>
                      <td>
                        {{ item.groupName }}
                      </td>
                      <td>
                        {{ item.createdAt | date: 'dd/MM/yyyy' }}
                      </td>
                      <td>
                        <div class="action-buttons">
                          <button
                            class="primary-button view-button"
                            (click)="fetchDataById(item.id)"
                          >
                            <mat-icon class="btn-icon">visibility</mat-icon>
                          </button>
                          @if (userRoleGroupDelete) {
                            <button
                              class="primary-button delete-button"
                              (click)="deleteRoleGroup(item.id)"
                            >
                              <mat-icon class="btn-icon">delete</mat-icon>
                            </button>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              }
              @if (listOfRoleGroup.length === 0) {
                <tbody>
                  <tr>
                    <td colspan="12">
                      <img
                        loading="lazy"
                        class="no-data-img"
                        src="../../assets/dataNotFound.jpg"
                        alt="nodatafound"
                      />
                    </td>
                  </tr>
                </tbody>
              }
            </table>
          </div>

          <!-- Separator between Body and Footer -->
          <div class="component-separator"></div>

          <div class="component-footer">
            @if (listOfRoleGroup.length > 0) {
              <app-common-component-pagination
                [totalItems]="totalItems"
                [pageSize]="pageSize"
                [currentPage]="pageNo"
                (pageChange)="onPageChange($event)"
                (sizeChange)="onSizeChange($event)"
              >
              </app-common-component-pagination>
            }
          </div>
        </div>
      </div>
    }

    @if (isAddRoleGroup) {
      <div>
        <form [formGroup]="addRoleGroupForm" novalidate>
          <div class="page-header">
            <div class="routing-buttons">
              <div
                class="action-button back-button"
                (click)="changePage()"
                tabindex="0"
                (keydown.enter)="changePage()"
              >
                <mat-icon class="icon back-icon">arrow_back</mat-icon>
              </div>
              <div
                class="action-button reload-button"
                (click)="onClickAddRoleRefresh()"
                tabindex="0"
                (keydown.enter)="onClickAddRoleRefresh()"
              >
                <mat-icon class="icon reload-icon">refresh</mat-icon>
              </div>
              <span class="page-title">Group Management</span>
            </div>
          </div>

          <div class="component-container">
            <div class="component-header">
              @if (isRoleGroupAddForm) {
                <h6 class="component-title">Add Group</h6>
              }
              @if (!isRoleGroupAddForm) {
                <h6 class="component-title">Update Group</h6>
              }
              <div class="component-actions"></div>
            </div>

            <!-- Separator between Header and Body -->
            <div class="component-separator"></div>

            <div class="component-body">
              <div class="form-section">
                <div class="form-group">
                  <label for="groupName" class="form-label">Group Name</label>
                  <mat-form-field appearance="outline">
                    <mat-label>Group Name</mat-label>
                    <input
                      matInput
                      id="groupName"
                      type="text"
                      placeholder="Group Name"
                      formControlName="groupName"
                      required
                    />
                    @if (
                      addRoleGroupForm.controls['groupName'].touched &&
                      addRoleGroupForm.controls['groupName'].errors
                        ?.requiredAndNoEmptySpaces
                    ) {
                      <mat-error>
                        {{
                          addRoleGroupForm.controls['groupName'].errors
                            ?.requiredAndNoEmptySpaces
                        }}
                      </mat-error>
                    }
                    @if (
                      addRoleGroupForm.controls['groupName'].touched &&
                      addRoleGroupForm.controls['groupName'].errors
                        ?.nonNumericNoSpecialChars
                    ) {
                      <mat-error>
                        {{
                          addRoleGroupForm.controls['groupName'].errors
                            ?.nonNumericNoSpecialChars
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Separator between Body and Footer -->
            <div class="component-separator"></div>

            <div class="component-footer">
              <div class="button-group right mb-2">
                @if (isRoleGroupAddForm && userRoleGroupCreate) {
                  <button class="submit-button" (click)="saveRoleGroup()">
                    Save<mat-icon class="btn-icon">check_circle</mat-icon>
                  </button>
                }
                @if (!isRoleGroupAddForm && userRoleGroupUpdate) {
                  <button class="edit-button" (click)="updateRoleGroup()">
                    Update <mat-icon class="btn-icon">edit</mat-icon>
                  </button>
                }
              </div>
            </div>
          </div>
        </form>
      </div>
    }
  </div>
}
